import React, { useEffect, useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import api from '../../components/Api';
import { useAppContext } from '../../context/AppContext';
import { JobProvider, useJobContext } from '../../context/JobContext';
import getUSPSSortation from '../../util/Sortation';
import Mapper from './Mapper'
import ReviewSubmit from './Review';
import { Input, Label, Selectbox } from '../../css/Shared';
import { Collapse } from 'react-collapse';
import MotionModal from '../../components/MotionModal';
import PermitForm from '../Permits/NewPermit';
import MailOwner from '../Permits/MailOwner';
import MailProvider from '../Permits/MailProvider';
import Products from '../Products/Products';
import DataCleanupTab from './DataCleanUp';
import SearchableSelect from '../../components/SearchableSelect';
import FacilitySearchSelect from '../../components/SearchableSelect';
import { Facilities } from '../../util/Facilities';
import {normalizedFacilities} from '../../util/Normalizedfacilities'


const JobDetailsForm = ({ permits, owners, providers, products, setSelectedTab,setPermits,setProviders,setOwners,setProducts,promotions}) => {
  const { formData, setFormData } = useJobContext();
   const [activeModal, setActiveModal] = useState(null);
   const [selectedItem, setSelectedItem] = useState(null);
  const [reset, setReset] = useState(false);
    const [npermits, setNpermits] = useState([]);
      const [isOpened, setIsOpened] = useState(false);

  const basePromotions = promotions

  const addOns = ['Informed Delivery', 'Sustainability'];

useEffect(() => {
 setFormData(prev => ({
        ...prev,
       no1Trays:"Auto",
       palletSize:"Regular",
       IMbarcode:true
      }))
},[])

  /* ---------- Update product info when productId changes ---------- */
  useEffect(() => {
    if (!formData.productId) {
      setFormData(prev => ({
        ...prev,
        product: null,
        height: '',
        length: '',
        thickness: '',
        weight: '',
        weightUnit: 'oz',
      }));
      return;
    }

    const selectedProduct = products.find(p => p._id === formData.productId);
    if (!selectedProduct) return;

    setFormData(prev => ({
      ...prev,
      product: selectedProduct,
      height: selectedProduct.height || '',
      length: selectedProduct.length || '',
      thickness: selectedProduct.thickness || '',
      weight: selectedProduct.weight || '',
      weightUnit: selectedProduct.weightUnit?.toLowerCase() || 'oz',
    }));
  }, [formData.productId, products, setFormData]);

  /* ---------- Update owner, provider, permit info when IDs change ---------- */
  useEffect(() => {
    if (formData.ownerId) {
      const o = owners.find(o => o._id === formData.ownerId);
      if (o) setFormData(prev => ({ ...prev, owner: o }));
    }
    if (formData.providerId) {
      const p = providers.find(p => p._id === formData.providerId);
      if (p) setFormData(prev => ({ ...prev, provider: p }));
    }
    if (formData.permitId) {
      const p = permits.find(p => p._id === formData.permitId);
      if (p) setFormData(prev => ({ ...prev, permit: p }));
    }
  }, [formData.ownerId, formData.providerId, formData.permitId, owners, providers, permits, setFormData]);

  /* ---------- Run USPS Sortation when product or mailClass changes ---------- */
  useEffect(() => {
    if (!formData.product || !formData.mailClass) return;

    const p = formData.product;

    const height = Number(p.height || 0);
    const length = Number(p.length || 0);
    const thickness = Number(p.thickness || 0);
    const weight =
      (p.weightUnit?.toLowerCase() === 'lbs'
        ? Number(p.weight || 0) * 16
        : Number(p.weight || 0)
      );

    if (!height || !length || !thickness || !weight) {
      setFormData(prev => ({
        ...prev,
        mailShape: '',
        aspectRatio: '',
        sortation: 'Invalid',
      }));
      return;
    }

    // Ensure mailClass is valid for USPS
    let mailClass = formData.mailClass;
    if (mailClass === "First") mailClass = "First-Class Mail";
    if (mailClass === "Standard") mailClass = "Marketing Mail";

    const result = getUSPSSortation({
      productHeight: height,
      productLength: length,
      productThickness: thickness,
      productWeight: weight,
      imBarcode: !!formData.IMbarcode,
      isFlexible: !(
        p.isNonFlexible ||
        p.isPolybagged ||
        p.isUnevenThickness ||
        p.hasLooseItems
      ),
      isUniformThickness: !(
        p.isNonFlexible ||
        p.isPolybagged ||
        p.isUnevenThickness ||
        p.hasLooseItems
      ),
      mailClass,
      quantity: 200,
    });

    if (!result?.error) {
      setFormData(prev => ({
        ...prev,
        mailShape: result.selectedCategory || '',
        aspectRatio: result.aspectRatio || '',
        sortation: result.sortation || '',
          reason: result.reason || '',

      }));
    } else {
      setFormData(prev => ({
        ...prev,
        mailShape: '',
        aspectRatio: '',
        sortation: 'Invalid',
          reason: result.reason || '',
      }));
    }
  }, [formData.product, formData.mailClass, formData.IMbarcode, setFormData, reset]);

// Replace your current provider useEffect with this improved version
useEffect(() => {
  if (!formData.providerId) {
    // Optional: clear POE when provider is cleared
    if (formData.poe !== null) {
      setFormData(prev => ({
        ...prev,
        poe: null,
        bmeuFacility: null
      }));
    }
    return;
  }

  const provider = providers.find(p => p._id === formData.providerId);
  if (!provider) return;

  // Set POE from provider if available
  if (provider.poe || provider.bmeuFacility) {
    const poeToSet = provider.poe || provider.bmeuFacility;

    // Only update if it's different to avoid unnecessary re-renders
    if (!formData.poe || formData.poe.fdbId !== poeToSet.fdbId) {
      setFormData(prev => ({
        ...prev,
        poe: poeToSet,
        bmeuFacility: poeToSet   // keep both in sync if you need it
      }));
    }
  }
}, [formData.providerId, providers, setFormData]);


  console.log(Facilities?.length)
    const openModal = (type, item = null) => {
    setSelectedItem(item);
    setActiveModal(type);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setActiveModal(null);
  };



console.log(formData)

const handlecreated = (newPermit) => {
  // 1. Add new permit to the permits array
  setPermits(prev => [...prev, newPermit]);

  // 2. Update formData to select this permit
  setFormData(prev => ({
    ...prev,
    permitId: newPermit._id,   // <- this is key for Selectbox
    permit: newPermit          // optional, if you keep the object
  }));
};

const handleProviderCreated = (newProvider) => {
  // Add new provider to the list
  setProviders(prev => [...prev, newProvider]);

  // Update formData to select this provider in the dropdown
  setFormData(prev => ({
    ...prev,
    providerId: newProvider._id,   // <- ensures <Selectbox> shows it selected
    provider: newProvider          // optional: store object if needed
  }));
};

const handleOwnerCreated = (newOwner) => {
  // 1. Add the new owner to the owners list
  setOwners(prev => [...prev, newOwner]);

  // 2. Immediately select it in the dropdown
  setFormData(prev => ({
    ...prev,
    ownerId: newOwner._id,  // <--- makes the <Selectbox> show it
    owner: newOwner          // optional: store full object if needed
  }));
};


const handleProductCreated = (newProduct) => {
  // add to list
  setProducts(prev => [...prev, newProduct]);

  // select it
  setFormData(prev => ({
    ...prev,
    productId: newProduct._id,   // 👈 THIS WAS MISSING
    product: newProduct
  }));
};

const isNextDisabled =
  !formData.jobDescription ||
  !formData.permitId ||
  !formData.ownerId ||
  !formData.providerId ||
  !formData.productId ||
  !formData.mailClass ||
  !formData.mailDate;

console.log(formData)
  return (
    <div className="bg-white border rounded-lg p-6 space-y-6 text-sm">
      {/* Job Description */}
      <div>
        <label className="block text-md font-medium text-gray-600 mb-1">
          Job Description / Title
        </label>
        <Input
        style={{border:'1px solid grey'}}
          type="text"
          value={formData.jobDescription || ''}
          onChange={(e) =>
            setFormData({ ...formData, jobDescription: e.target.value })
          }
          className="w-full h-9 px-3 border rounded-md"
        />
      </div>

      {/* Product / Class / Date */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">

        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: '12px', fontWeight: '600' }}>Products</div>
            <button
              type="button"
              style={{
                fontSize: '10px',
                padding: '2px 6px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                background: '#f9f9f9',
                cursor: 'pointer'
              }}
               onClick={() => openModal('product')}
            >
              New Product
            </button>
          </div>
        <Selectbox
          value={formData.productId || ''}
          onChange={(e) =>
            setFormData({ ...formData, productId: e.target.value })
          }
          className="h-7 px-2 text-xs border rounded-md"

        >
          <option value="">Select Product</option>
          {products?.map(p => (
            <option key={p._id} value={p._id}>{p.name}</option>
          ))}
        </Selectbox>
</div>
       <div style={{flex:'.5'}}>
       <div style={{ fontSize: '12px', fontWeight: '600',paddingBottom:'6px' }}>Mail Class</div>
     <Selectbox
  value={formData.mailClass || ''}
  onChange={(e) =>
    setFormData({ ...formData, mailClass: e.target.value })
  }
  className="h-7 px-2 text-xs border rounded-md"
>
  <option value="" disabled={true}>Mail Class</option>
  <option value="First">First-Class</option>
  <option value="Standard">Standard</option>
  <option value="Nonprofit">Nonprofit</option>
</Selectbox>
</div>
<div>
  <div style={{ fontSize: '12px', fontWeight: '600',paddingBottom:'6px' }}>Mail Date</div>
        <Input
          type="date"
          value={formData.mailDate || ''}
          onChange={(e) =>
            setFormData({ ...formData, mailDate: e.target.value })
          }
          className="h-7 px-2 text-xs border rounded-md"

        />
        </div>
            {/* USPS Job ID */}
    <div >
      <div style={{ fontSize: '12px', fontWeight: '600',paddingBottom:'6px' }}>
        Job ID
      </div>
      <Input
        type="text"
        placeholder="Enter USPS Job ID"
        maxLength="8"
        value={formData.uspsJobId || ''}
        onChange={(e) =>
          setFormData(prev => ({
            ...prev,
            uspsJobId: e.target.value
          }))
        }
        className="h-7 px-2 text-xs border rounded-md"

      />
    </div>
      </div>
   
      {/* Permit / Owner / Provider */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: '12px', fontWeight: '600' }}>Permit Holder</div>
            <button
              type="button"
              style={{
                fontSize: '10px',
                padding: '2px 6px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                background: '#f9f9f9',
                cursor: 'pointer'
              }}
              onClick={() => openModal('permit')}
            >
              New Permit
            </button>
          </div>
        <Selectbox
          value={formData.permitId || ''}
          onChange={(e) =>
            setFormData({ ...formData, permitId: e.target.value })
          }
          className="h-7 px-2 text-xs border rounded-md"

          
        >
          <option value="">Select Permit</option>
          {permits?.map(p => (
            <option key={p._id} value={p._id}>{p.permitName}</option>
          ))}
        </Selectbox>
</div>

  <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: '12px', fontWeight: '600' }}>Mail Owner</div>
            <button
              type="button"
              style={{
                fontSize: '10px',
                padding: '2px 6px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                background: '#f9f9f9',
                cursor: 'pointer'
              }}
              onClick={() => openModal('owner')}
            >
              New Owner
            </button>
          </div>
        <Selectbox
          value={formData.ownerId || ''}
          onChange={(e) =>
            setFormData({ ...formData, ownerId: e.target.value })
          }
          className="h-7 px-2 text-xs border rounded-md"

        >
          <option value="">Select Owner</option>
          {owners?.map(p => (
            <option key={p._id} value={p._id}>{p.companyName}</option>
          ))}
        </Selectbox>
</div>

<div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: '12px', fontWeight: '600' }}>Mail Service Provider</div>
            <button
              type="button"
              style={{
                fontSize: '10px',
                padding: '2px 6px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                background: '#f9f9f9',
                cursor: 'pointer'
              }}
              onClick={() => openModal('provider')}
            >
              New Provider
            </button>
          </div>
        <Selectbox
          value={formData.providerId || ''}
          onChange={(e) =>
       setFormData(prev => ({
  ...prev,
  providerId: e.target.value
}))

          }
          className="h-7 px-2 text-xs border rounded-md"

        >
          <option value="">Select Provider</option>
          {providers?.map(p => (
            <option key={p._id} value={p._id}>{p.providerName}</option>
          ))}
        </Selectbox>
</div>

      </div>




<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
  <div className="" style={{marginRight:'30px'}}>
    <label style={{ fontSize: '12px', fontWeight: '600' }}>

    Drop Shipping<br />
    </label>
      <Input
        type="text"
        placeholder="Drop Ship Company"
        value={formData?.dropshipname || ''}
        onChange={(e) =>
          setFormData(prev => ({
            ...prev,
            dropshipname: e.target.value
          }))
        }
        className="text-xs max-w-xs"
      />
  
  </div>
 
    <div className='col-span-2' style={{ fontSize: '12px', fontWeight: '600' }} >
  Post Office Entry Location<br />
<FacilitySearchSelect
  facilities={normalizedFacilities}
  value={formData.poe}
  onChange={(facility) =>
    setFormData(prev => ({
      ...prev,
      poe: facility 
    }))
  }
/>
</div>
</div>


  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">

    {/* Small Pallets */}
    <div>
      <div style={{ fontSize: '12px', fontWeight: '600' }}>
        Pallet Size
      </div>
      <Selectbox
        value={formData.palletSize || ''}
        onChange={(e) =>
          setFormData(prev => ({
            ...prev,
            palletSize: e.target.value
          }))
        }
        className="h-7 px-2  border rounded-md"

      >
        <option value="Small">Small</option>
        <option value="Regular">Regular</option>
        <option value="Tall">Tall</option>
       
      </Selectbox>
    </div>

 <div>
      <div style={{ fontSize: '12px', fontWeight: '600' }}>
           Tray Type
      </div>

  <Selectbox
    value={formData.no1Trays || ""}
    onChange={(e) =>
      setFormData(prev => ({
        ...prev,
        no1Trays: e.target.value
      }))
    }
    className="h-7 px-2  border rounded-md"
  >
    <option value="Auto">Auto</option>
    <option value="EMM">EMM</option>
    <option value="MM">MM</option>
  </Selectbox>
    </div>
  </div>

  

<div className="grid grid-cols-1 md:grid-cols-5 gap-4 pt-4 mt-4 text-xs">
  
  <label className="flex items-center gap-2 justify-start md:justify-center">
    <input
      type="checkbox"
      checked={formData.growthIncentive}
      onChange={(e) =>
        setFormData(prev => ({ ...prev, growthIncentive: e.target.checked }))
      }
      className="h-4 w-4 flex-shrink-0"
    />
    <span className="text-left">Growth Incentive Credit Redemption</span>
  </label>

  <label className="flex items-center gap-2 justify-start md:justify-center">
    <input
      type="checkbox"
      checked={formData.ballotbox}
      onChange={(e) =>
        setFormData(prev => ({ ...prev, ballotbox: e.target.checked }))
      }
      className="h-4 w-4 flex-shrink-0"
    />
    <span className="text-left">Ballot Mail</span>
  </label>

  <label className="flex items-center gap-2 justify-start md:justify-center">
    <input
      type="checkbox"
      checked={formData.political}
      onChange={(e) =>
        setFormData(prev => ({ ...prev, political: e.target.checked }))
      }
      className="h-4 w-4 flex-shrink-0"
    />
    <span className="text-left">Political Mail</span>
  </label>

  <label className="flex items-center gap-2 justify-start md:justify-center">
    <input
      type="checkbox"
      checked={formData.IMbarcode}
      onChange={(e) =>
        setFormData(prev => ({ ...prev, IMbarcode: e.target.checked }))
      }
      className="h-4 w-4 flex-shrink-0"
    />
    <span className="text-left">IM Barcode</span>
  </label>

  <label className="flex items-center gap-2 justify-start md:justify-center">
    <input
      type="checkbox"
      checked={formData.unevenThickness}
      onChange={(e) =>
        setFormData(prev => ({ ...prev, unevenThickness: e.target.checked }))
      }
      className="h-4 w-4 flex-shrink-0"
    />
    <span className="text-left">Uneven Thickness</span>
  </label>

</div>


<div className="border-t ">
  <div className="text-md font-bold mb-3">Promotions</div>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-start">

    {/* Yes / No */}
    {/* <div>
       <div className="text-xs font-medium text-gray-600 mb-2">
        Promotions
      </div> 
       <div className="flex gap-6">
        <label className="flex items-center gap-2 text-sm">
          <input
            type="radio"
            name="promotions"
            checked={formData.promotions}
            onChange={() =>
              setFormData(prev => ({
                ...prev,
                promotions: 1
              }))
            }
          />
          Yes
        </label>

        <label className="flex items-center gap-2 text-sm">
          <input
            type="radio"
            name="promotions"
            checked={!formData.promotions}
            onChange={() =>
              setFormData(prev => ({
                ...prev,
                promotions: 0,
                basepromotions: '',
                addon1: '',
                addon2: ''
              }))
            }
          />
          No
        </label>
      </div> 
    </div> */}

    {/* Base Promotion */}
      <>
    
        <div>
          <Selectbox
            value={formData.basepromotions || ''}
            onChange={(e) =>
              setFormData(prev => ({
                ...prev,
                basepromotions: e.target.value
              }))
            }
            className="h-7 px-2 text-xs border rounded-md"

          >
            <option value="" >None</option>
            {basePromotions?.map((promo, index) => {
            return  <option key={index} value={promo.name}>
                {promo.name}
              </option>
})}
          </Selectbox>
        </div>

        {/* Add-Ons */}
        <div style={{marginTop:'-20px'}}>
          <div className="text-xs font-medium text-gray-600 mb-2">
            Add-Ons
          </div>

          <div className="text-sm flex  " style={{alignItems:'center'}}>
            <label style={{marginRight:'30px'}}>
              <input
              style={{marginRight:'10px'}}
                type="checkbox"
                checked={formData.addon1 === 'Informed Delivery'}
                onChange={(e) =>
                  setFormData(prev => ({
                    ...prev,
                    addon1: e.target.checked ? 'Informed Delivery' : ''
                  }))
                }
              />
              Informed Delivery
            </label>

            <label className=" gap-2">
              <input
              style={{marginRight:'10px'}}
                type="checkbox"
                checked={formData.addon2 === 'Sustainability'}
                onChange={(e) =>
                  setFormData(prev => ({
                    ...prev,
                    addon2: e.target.checked ? 'Sustainability' : ''
                  }))
                }
              />
              Sustainability
            </label>
          </div>
        </div>
      </>

  </div>
</div>



                      <div className="mt-4 border-t pt-4">
                  <div className="flex whitespace-nowrap">
                    <h3 className="text-md font-bold mb-2 mr-4">Advanced Options</h3>
                    <svg
                      onClick={() => setIsOpened(!isOpened)}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="size-5"
                    >
                      <path d="M10.75 2.75a.75.75 0 0 0-1.5 0v8.614L6.295 8.235a.75.75 0 1 0-1.09 1.03l4.25 4.5a.75.75 0 0 0 1.09 0l4.25-4.5a.75.75 0 0 0-1.09-1.03l-2.955 3.129V2.75Z" />
                      <path d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z" />
                    </svg>
                  </div>
                <Collapse isOpened={isOpened}>

  Here we can put things like maybe tray max, tray min, pallet max, pallet min,  etc.....



</Collapse>

                </div>






      {/* Display Sortation Results */}
      <div style={{marginTop:'40px',fontWeight:'bold'}}>ONLY HERE FOR TESTING, CHRIS.
      <div className="text-xs text-gray-600 space-y-1">
        <div>Mail Shape: <span className="font-medium text-gray-900">{formData.mailShape || '—'}</span></div>
        <div>Aspect Ratio: <span className="font-medium text-gray-900">{formData.aspectRatio || '—'}</span></div>
        <div>Sortation: <span className="font-medium text-gray-900">{formData.sortation || '—'}</span></div>
          <div>Reason: <span className="font-medium text-gray-900">{formData.reason || '—'}</span></div>
      </div> 
</div>

<div className="flex justify-end">
  <button
    onClick={() => setSelectedTab(1)}
    disabled={isNextDisabled}
    className={`px-4 py-1 rounded ${
      isNextDisabled
        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
        : 'bg-blue-500 text-white hover:bg-blue-600'
    }`}
  >
    Next &gt;
  </button>
</div>
      
      {/* ===== MODALS ===== */}
      <MotionModal open={activeModal === 'permit'} onClose={closeModal}>
        <PermitForm normalizedFacilities={normalizedFacilities} permit={selectedItem} onClose={closeModal} onCreated={handlecreated} reset={reset}/>
      </MotionModal>

      {/* <MotionModal open={activeModal === 'provider'} onClose={closeModal}>
        <MailProvider provider={selectedItem} onClose={closeModal} />
      </MotionModal> */}
<MotionModal open={activeModal === 'provider'} onClose={closeModal} >
  <MailProvider
    provider={selectedItem}
    onClose={closeModal}
    onCreated={handleProviderCreated}
    normalizedFacilities={normalizedFacilities}
  />
</MotionModal>


      <MotionModal open={activeModal === 'owner'} onClose={closeModal}>
        <MailOwner owner={selectedItem} onClose={closeModal} onCreated={handleOwnerCreated}/>
      </MotionModal>

      <MotionModal open={activeModal === 'product'} onClose={closeModal}>
        <Products product={selectedItem} onClose={closeModal}  onCreated={handleProductCreated}/>
      </MotionModal>
    </div>
  );
};

const AccurintReportScreen = () => {
  const { authState } = useAppContext();

  const [permits, setPermits] = useState([]);
  const [owners, setOwners] = useState([]);
  const [providers, setProviders] = useState([]);
  const [products, setProducts] = useState([]);
   const [promotions, setPromotions] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
const goToNextTab = () => setSelectedTab((t) => t + 1);
  const goToPrevTab = () => setSelectedTab((t) => t - 1);
  useEffect(() => {
    if (!authState?.user?.company) return;

    const load = async () => {
      const [p, o, pr, prod,promos] = await Promise.all([
        api.post('/permits/getpermitholder', { id: authState.user.company }),
        api.post('/permits/getmailowners', { id: authState.user.company }),
        api.post('/permits/getmailproviders', { id: authState.user.company }),
        api.post('/products/getproducts', { id: authState.user.company }),
         api.get('/settings/basepromotions'),
      ]);

      setPermits(p.data);
      setOwners(o.data);
      setProviders(pr.data);
      setProducts(prod.data.products || []);
       console.log(promos.data.promos)
       setPromotions(promos.data.promos);
      
    };

    load();
  }, [authState]);


  
  
  return (
    <JobProvider>
      <div className="max-w-6xl mx-auto px-4 py-6">
       <Tabs
  selectedIndex={selectedTab}
  onSelect={() => false} // disables tab clicks
>
          <TabList className="flex gap-6 border-b text-xs font-medium text-gray-600 mb-4">
            <Tab>Job Details</Tab>
            <Tab>List Mapping</Tab>
            <Tab>List Cleaning</Tab>
            <Tab>Job Review</Tab>
          </TabList>

          <TabPanel>
           <JobDetailsForm
  permits={permits}
  setPermits={setPermits}
  setProviders={setProviders}
  setOwners={setOwners}
  owners={owners}
  providers={providers}
  products={products}
  setProducts={setProducts}
  setSelectedTab={setSelectedTab}
  promotions={promotions}
/>

          </TabPanel>

          <TabPanel>
           <Mapper goToNextTab={goToNextTab} goToPrevTab={goToPrevTab}/>
          </TabPanel>
 <TabPanel>
       <DataCleanupTab goToNextTab={goToNextTab} goToPrevTab={goToPrevTab}/>
          </TabPanel>
          <TabPanel>
         <ReviewSubmit goToPrevTab={goToPrevTab}/>
          </TabPanel>
        </Tabs>
      </div>

      

    </JobProvider>
  );
};

export default AccurintReportScreen;






